/**
 * nd-personalization-utils.js
 * Shared utilities for the ?product= personalization system.
 */
window.NDPersonalization = (function () {
  'use strict';

  var PASSTHROUGH_PARAMS = ['product', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'sccid', 'ttclid', 'gclid'];

  /**
   * Parse ?product= from URL, falling back to sessionStorage.
   * @param {string} [storageKeySuffix] — appended to storage key for scoping (e.g. pathname)
   * @returns {string|null} normalized handle or null
   */
  function getProductHandle(storageKeySuffix) {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('product');
    if (handle) handle = handle.trim().toLowerCase();
    if (handle && handle.length > 200) return null;
    if (handle && !/^[a-z0-9][-a-z0-9]*$/.test(handle)) return null;

    if (!handle && storageKeySuffix) {
      try {
        var raw = sessionStorage.getItem('nd_personalized_product_' + storageKeySuffix);
        if (raw) {
          var data = JSON.parse(raw);
          if (Date.now() - data.ts > 30 * 60 * 1000) {
            sessionStorage.removeItem('nd_personalized_product_' + storageKeySuffix);
          } else {
            handle = data.handle;
          }
        }
      } catch (e) {
        // JSON.parse fails for old bare-string format — treat as expired
        try { sessionStorage.removeItem('nd_personalized_product_' + storageKeySuffix); } catch (e2) {}
      }
      if (handle && !/^[a-z0-9][-a-z0-9]*$/.test(handle)) handle = null;
    }

    return handle || null;
  }

  /**
   * Persist handle to sessionStorage for session continuity.
   */
  function storeProductHandle(storageKeySuffix, handle) {
    try {
      sessionStorage.setItem('nd_personalized_product_' + storageKeySuffix, JSON.stringify({
        handle: handle,
        ts: Date.now()
      }));
    } catch (e) { /* swallow */ }
  }

  /**
   * Reorder a container's children to move the element matching `handle` to first position.
   * @param {Element} container — parent element
   * @param {string} selector — child selector (e.g. 'li.grid__item', '.vv-card')
   * @param {string} handle — product handle to match
   * @param {string} [handleAttr='data-product-handle'] — attribute holding the handle
   * @returns {Element|null} the matched element, or null
   */
  function reorderByHandle(container, selector, handle, handleAttr) {
    handleAttr = handleAttr || 'data-product-handle';
    var items = container.querySelectorAll(selector);
    var matched = null;

    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute(handleAttr) === handle) {
        matched = items[i];
        break;
      }
    }

    if (!matched || matched === items[0]) return null;
    container.insertBefore(matched, container.firstElementChild);
    return matched;
  }

  return {
    PASSTHROUGH_PARAMS: PASSTHROUGH_PARAMS,
    getProductHandle: getProductHandle,
    storeProductHandle: storeProductHandle,
    reorderByHandle: reorderByHandle
  };
})();
